import * as React from "react";
import type { SVGProps } from "react";
const SvgImage04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M4.693 17.293a1 1 0 1 0 1.414 1.414L5.4 18zM8.4 15l.707-.707a1 1 0 0 0-1.414 0zm2.4 2.4-.707.707a1 1 0 0 0 1.414 0zm5.4-5.4.707-.707a1 1 0 0 0-1.414 0zm3.493 4.907a1 1 0 0 0 1.414-1.414l-.707.707zM5.4 18l.707.707 3-3L8.4 15l-.707-.707-3 3zm3-3-.707.707 2.4 2.4.707-.707.707-.707-2.4-2.4zm2.4 2.4.707.707 5.4-5.4L16.2 12l-.707-.707-5.4 5.4zm5.4-5.4-.707.707 4.2 4.2.707-.707.707-.707-4.2-4.2zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zm9.6-9.6h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm0 0v-1C6.146 1.4 1.4 6.146 1.4 12h2A8.6 8.6 0 0 1 12 3.4zM10.8 9h-1a.8.8 0 0 1-.8.8v2A2.8 2.8 0 0 0 11.8 9zM9 10.8v-1a.8.8 0 0 1-.8-.8h-2A2.8 2.8 0 0 0 9 11.8zM7.2 9h1a.8.8 0 0 1 .8-.8v-2A2.8 2.8 0 0 0 6.2 9zM9 7.2v1a.8.8 0 0 1 .8.8h2A2.8 2.8 0 0 0 9 6.2z"
    />
  </svg>
);
export default SvgImage04;
